export {
  TONE_COLOR_DARK_HEX_FIELD_DICT,
  TONE_COLOR_LIGHT_HEX_FIELD_DICT,
  type HanziScript,
  type ToneColorHexField,
  type ToneColorScheme,
  type ToneNumber,
} from "#actor-types";
